/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cropzoom1Inputs */

const en_cropzoom1 = /** @type {(inputs: Cropzoom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const de_cropzoom1 = /** @type {(inputs: Cropzoom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

/**
* | output |
* | --- |
* | "Zoom" |
*
* @param {Cropzoom1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cropzoom1 = /** @type {((inputs?: Cropzoom1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cropzoom1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cropzoom1(inputs)
	return de_cropzoom1(inputs)
});
export { cropzoom1 as "cropZoom" }